import { HighlightCard } from 'ui/cards'
import React from 'react'
import * as Displays from 'support/displays'
import { ReadOnlyModel, useModelKey, useValue, WhenModel } from '@morningtrain/react-resources'
import { observer } from 'mobx-react'
import ScheduleCostDistributionHighlightCard from 'widgets/shifts/ScheduleCostDistributionHighlightCard'
import { Translation } from '@morningtrain/react-translations'
import ScheduleWageRatioHighlightCard from 'widgets/shifts/ScheduleWageRatioHighlightCard'
import {Env} from "@morningtrain/helpers";

function ScheduleHighlightCards () {
  const scheduleId = useModelKey()
  const week = useValue('week')
  const hasWaiter = Env.get('globals.has_waiter');
  const hasKitchen = Env.get('globals.has_kitchen');

  return (
    <WhenModel>
      <ReadOnlyModel resourceName='shifts.schedule' operationName='summary'>
        { (hasWaiter && hasKitchen) ? <ScheduleCostDistributionHighlightCard scheduleId={scheduleId} /> : false}
        <HighlightCard
          box={<Displays.Integer name='average_hourly_rate' />}
          title={<Translation name='shifts.planner.average_hourly_rate.title' />}
          content={<Translation name='shifts.planner.average_hourly_rate.content' data={{ week: week }} />}
        />
        <ScheduleWageRatioHighlightCard week={week} />
      </ReadOnlyModel>
    </WhenModel>
  )
}

export default observer(ScheduleHighlightCards)
